import types from '../types';
const {
  SET_GLOBAL_ERROR,
  SET_LOADING,
  SET_ERROR,
  SET_ADMIN,
  SET_AUTH_ERROR,
  SET_SUCCESS,
  SET_FEEDBACKS,
  SET_INIT_LOADING,
  SET_USERS,
  SET_DRIVERS,
  SET_RIDES,
  SET_RIDES_REALTIME_STAT,
  SET_CURRENT_CAR_PRICES,
  SET_DELETE_SUCCESS,
} = types;

const dashboardReducer = (state, action) => {
  switch (action.type) {
    case SET_ADMIN:
      return {
        ...state,
        admin: action.payload,
      };
    case SET_GLOBAL_ERROR:
      return {
        ...state,
        globalError: action.payload,
      };
    case SET_SUCCESS:
      return {
        ...state,
        success: action.payload,
      };
    case SET_DELETE_SUCCESS:
      return {
        ...state,
        deleteSuccess: action.payload,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SET_INIT_LOADING:
      return {
        ...state,
        initLoading: action.payload,
      };
    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case SET_AUTH_ERROR:
      return {
        ...state,
        authError: action.payload,
      };
    case SET_FEEDBACKS:
      return {
        ...state,
        feedbacks: action.payload,
      };
    case SET_DRIVERS:
      return {
        ...state,
        drivers: action.payload,
      };
    case SET_USERS:
      return {
        ...state,
        users: action.payload,
      };
    case SET_RIDES:
      return {
        ...state,
        rides: action.payload,
      };
    case SET_RIDES_REALTIME_STAT:
      return {
        ...state,
        ridesRealtimeStat: action.payload,
      };
    case SET_CURRENT_CAR_PRICES:
      return {
        ...state,
        currentPrices: {
          ...state.currentPrices,
          [action.payload.carType]: action.payload.price,
        },
      };
    default:
      return state;
  }
};

export default dashboardReducer;
